module.exports = __webpack_public_path__ + "static/home-jumbotron-858cdc81a9d637b36f4ba909d15a668e.png";